export default {
	logo: require("./logo.png"),
	name: require("./name.png"),
	logoDark: require("./logo-dark.png"),
	nameDark: require("./name-dark.png"),
}
